import React from 'react';

import FormField from 'components/atoms/Form/FormField';
import TextForm from 'components/molecules/TextForm';
import FormSubmitArea from 'components/atoms/Form/FormSubmitArea';
import Button from 'components/atoms/Button';
import { Link, useParams } from 'react-router-dom';
import ConfirmModal from 'components/organismos/ConfirmModal';
import FormContents from 'components/atoms/Form/FormContents';
import { useSelector } from 'react-redux';
import { Store } from 'modules/store';
import { useAttendAllowanceAddForm } from './hooks';

/**
 * 手当マスタ 登録・編集フォーム（C3_RESDUC-1877）
 * 手本: components/organismos/Executive/ExecutiveAddForm
 */
const AttendAllowanceAddForm: React.FC = () => {
  const { allowanceId } = useParams();
  const {
    formik, confirmModalOpen, closeConfirmModal,
  } = useAttendAllowanceAddForm(allowanceId);

  const roleScreen = useSelector((state: Store) => state.auth.roleScreen);

  return (
    <div>
      <FormContents>
        <p>
          手当マスタを登録します。ここで登録した手当のうち、雇用形態設定で選択したものが手当申請画面に表示されます。
        </p>
        <form>
          <FormField>
            <TextForm
              name="allowanceCode"
              label="手当コード"
              value={formik.values.allowanceCode}
              required={true}
              onChange={formik.handleChange}
              errorMsg={formik.errors.allowanceCode}
            />
          </FormField>
          <FormField>
            <TextForm
              name="allowanceName"
              label="手当名"
              value={formik.values.allowanceName}
              required={true}
              onChange={formik.handleChange}
              errorMsg={formik.errors.allowanceName}
            />
          </FormField>
          <FormField>
            <TextForm
              name="dispMessage"
              label="表示メッセージ"
              value={formik.values.dispMessage}
              required={true}
              onChange={formik.handleChange}
              errorMsg={formik.errors.dispMessage}
              note="申請画面の「申請内容」列に表示する説明です。例：立替払いした金額を入力してください"
            />
          </FormField>
          <FormField>
            <TextForm
              name="dispUnit"
              label="単位"
              value={formik.values.dispUnit || ''}
              onChange={formik.handleChange}
              errorMsg={formik.errors.dispUnit}
              note="申請画面の入力欄の右に表示します。例：円、回。表示専用で計算には使いません"
            />
          </FormField>
          <FormSubmitArea>
            {
              roleScreen && roleScreen.editable === 1 && (
                <div style={{ marginRight: '12px' }}>
                  <Button
                    text={allowanceId ? '手当を更新' : '手当を登録'}
                    onClick={formik.handleSubmit}
                  />
                </div>
              )
            }
            <Link to="/masterAttendAllowance">
              <Button
                text="戻る"
                ghost={true}
              />
            </Link>
          </FormSubmitArea>
        </form>
      </FormContents>

      <ConfirmModal
        title="確認メッセージ"
        content={allowanceId ? '更新します。よろしいですか？' : '登録します。よろしいですか？'}
        open={confirmModalOpen}
        closeHandler={closeConfirmModal}
        onSubmit={formik.submitForm}
        items={[]}
      />
    </div>
  );
};

export default AttendAllowanceAddForm;
